import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { Section } from "@/components/Section";
import { KeyIdea } from "@/components/Callouts";

export default function EdSheeran8() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "8");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section title="Chord Chart">
        <NoteImage
          src="/notes/ed-sheeran/finals/08-a-little-more.png"
          caption="Jason's chord chart for A Little More"
        />
      </Section>

      <Section title="The Whole Song — Two Chords">
        <RomanNumeralAnalysis
          label="Entire song · B♭ major"
          chords={[
            { chord: "Bbmaj7", rn: "Imaj7", function: "Tonic", pitches: ["Bb2", "D3", "F3", "A3"] },
            { bar: true },
            { chord: "Cm7", rn: "ii7", function: "Pre-dominant", pitches: ["C3", "Eb3", "G3", "Bb3"] },
          ]}
        />
        <KeyIdea title="Special moment">
          B♭maj7 for two bars, Cm7 for two bars — that is the whole chart. The power is in the
          melody and the space between notes, not in harmonic complexity. Jason's chart carries a
          three-flat (E♭ major) key signature; the A in B♭maj7 is the one note outside it.
        </KeyIdea>
      </Section>

      <Section title="Watch">
        <YouTubeEmbed videoId="O_0Wn73AnC8" />
      </Section>
    </LessonShell>
  );
}
